module.exports = __webpack_public_path__ + "img/261.0592fb20.jpg";